import styled from "styled-components";

/**
 * A dashboard row of two equal widgets, stacking to one column on a narrow
 * window. Every paired row on the New tab is one of these.
 *
 * `min-width: 0` on the children is load-bearing, not tidiness: a 1fr track
 * is `minmax(auto, 1fr)`, so a child with wide content — a long unbroken
 * string, a table, a streaming answer — drags its column wider and squeezes
 * the widget beside it.
 */
export const DashboardHalves = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: stretch;

  > * {
    min-width: 0;
  }

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;
